module.exports = {
  default: require('./default.hbs'),
  noButton: require('./noButton.hbs'),
  oneButton: require('./oneButton.hbs'),
  twoButtons: require('./twoButtons.hbs'),
  welcome: require('./welcome.hbs'),
  cards: require('./cards.hbs'),
  languageSelection: require('./languageSelection.hbs')
};
